import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtm from 'vue-gtm';
import gtmOptions from './gtm-options.js'

Vue.use(VueRouter)
Vue.use(VueGtm, gtmOptions);

import axios from "axios";

// Components
import LoadingSpinner from './components/loading-spinner.vue';


// Masonry Layout
var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Masonry = require('masonry-layout');

// make Masonry a jQuery plugin
jQueryBridget( 'masonry', Masonry, $ );


// Vue Router settings
const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/knowledge/:section(blog|events|white-papers)?/:page(p\\d+)?',
      name: 'knowledge'
    }
  ]
});

const baseUrl = '/knowledge';

// CancelTokens for canceling previous Axios requests.
const CancelToken = axios.CancelToken;
let source;


if (document.getElementById('knowledge-search') != null) {
  new Vue({
    router,
    data() {
      return {
        searchInput: '',
        query: '',
        category: '',
        section: '',
        isLoading: false,
        searchResults: [],
        noResults: false,
        currentPage: window.__SEARCH__.pageNum || 1,
        nextPage: (window.__SEARCH__.pageNum + 1) || null,
        prerendered: true,
        showPrerenderedNextPage: true,
        totalPages: null,
        grid: null,
      }
    },
    methods: {
      updateSearchParams: function() {
        this.query = this.$route.query.q || '';
        this.searchInput = this.query;
        this.category = this.$route.query.category || '';
        this.section = this.$route.params.section || '';
      },
      pushHistory: function() {
        let params = {}
        if (this.section.length > 0) {
          params.section = this.section;
        }

        this.$router.push({
          name: 'knowledge',
          params: params,
          query: this.queryParams
        });
      },
      setQuery: function () {
        if (this.query != this.searchInput) {
          this.newSearch();
        }
      },
      setCategory: function (category) {
        // We check so see if the search input has changed also.
        // If the user typed a search term then clicks on a section tab
        // or category dropdown item _without_ hitting return first, we still
        // want to run a new search.
        if (category !== this.category || this.query !== this.searchInput) {
          this.category = category;
          this.newSearch();
        }
      },
      setSection: function (section) {
        // See note in setCategory function.
        if (section !== this.section || this.query !== this.searchInput) {
          this.section = section;
          this.newSearch();
        }
      },
      loadMore: function() {
        this.fetchEntries();
      },
      newSearch: function() {
        this.query = this.searchInput;
        this.currentPage = 1;
        this.nextPage = null;
        this.searchResults = [];
        this.prerendered = false;

        this.pushHistory();
      },
      fetchEntries: function() {
        if (source) {
          source.cancel();
        }
        source = axios.CancelToken.source();

        this.isLoading = true;
        this.showPrerenderedNextPage = false;

        axios.get(this.searchApi, {
          cancelToken: source.token
        })
        .then(response => {
          this.isLoading = false;

          // Using the spread operator here because Array.prototype.push.apply()
          // doesn't update the watcher on searchResults for some reason.
          [...this.searchResults] = [...this.searchResults, ...response.data.data]

          let pagination = response.data.meta.pagination;

          this.currentPage = pagination.current_page;
          this.totalPages = pagination.total_pages;

          if (this.currentPage < this.totalPages) {
            this.nextPage = this.currentPage + 1;
          } else {
            this.nextPage = 0;
          }

          this.track();
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            // console.log('Request canceled');
          } else {
            this.isLoading = false;
            console.log('Error', error.message);
          }
        })
        .then(() => {
        });
      },
      track: function() {
        this.$gtm.trackEvent({
          event: 'search',
          category: 'knowledge',
          searchKeywords: this.query,
          searchSection: this.section,
          searchCategory: this.category,
          pageNumber: this.currentPage
        });
      }
    },
    computed: {
      sectionUrl: function() {
        return this.section ? `/${this.section}` : ''
      },
      queryParams: function() {
        let params = {};
        if (this.query) {
          params.q = this.query;
        }
        if (this.category) {
          params.category = this.category;
        }
        return params;
      },
      queryString: function() {
        let params = $.param(this.queryParams);
        return (params.length > 0) ? `?${params}` : '';
      },
      searchApi: function() {
        if (this.nextPage > 1) {
          return `${baseUrl}.json${this.sectionUrl}/p${this.nextPage}${this.queryString}`;
        } else {
          return `${baseUrl}.json${this.sectionUrl}${this.queryString}`;
        }
      },
      showNextPage: function() {
        return (this.nextPage > 1 && this.isLoading === false && this.showPrerenderedNextPage === false);
      },
      nextPageUrl: function() {
        if (this.nextPage > 1 && (this.currentPage < this.totalPages)) {
          return `${baseUrl}${this.sectionUrl}/p${this.nextPage}${this.queryString}`;
        } else {
          return null;
        }
      },
      showNoResults: function() {
        return (this.searchResults.length < 1 && this.isLoading === false && this.prerendered === false);
      },
    },
    watch: {
      searchResults: function(newVal, oldVal) {
        this.$nextTick(function() {
          this.grid.masonry('reloadItems').masonry();
        });
      },
      $route(to, from) {
        if (to != from) {
          this.fetchEntries();
        }
      }
    },
    created: function() {
      this.updateSearchParams();
    },
    mounted: function() {
      this.grid = $('#knowledge-search .masonry-grid');
      this.grid.masonry({
        itemSelector: '.masonry-grid__cell',
        columnWidth: '.masonry-grid__cell',
        percentPosition: true,
        transitionDuration: 0,
        horizontalOrder: true
      });
    },
    components: {
      LoadingSpinner
    }
  }).$mount('#knowledge-search')
}
